import { useEffect, useState } from 'react';
import { Colors, Text } from '@mercator-gcp/grout';

const loadingMessages = [
  'This may take a few minutes as we gather the most accurate information.',
  'Still thinking...',
  'Sit tight, almost done...',
  'Your request is taking a little longer to process due to its complexity. Thanks for your patience!',
  'Crunching data...',
  'Just a moment more...',
  'Almost there...',
];

const LoadingStateThinking = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Text.Small color={Colors.TextQuiet}>{loadingMessages[messageIndex]}</Text.Small>
  );
};

export default LoadingStateThinking;
